import { useContext } from "react";
import { Context } from "../context/AppContext";
import { useNavigate } from "react-router-dom";

function OrderStore() {
  const navigate = useNavigate();
  const { setRestaurantId } = useContext(Context);

  const handleToOrder = (id) => {
    setRestaurantId(id);
    navigate("/online-order");
  };

  const locations = [
    {
      id: 7,
      title: "Cordova Location",
      address: "1250 N Germantown Pkwy",
      city: "Cordova, TN 38016",
      phone: "(901) 707-8886",
    },
    {
      id: 11,
      title: "Overton Square Location",
      address: "2110 Madison Ave",
      city: "Memphis, TN 38104",
      phone: "(901) 207-6680",
    },
    {
      id: 40,
      title: "小富贵 Little Petal Chinese(Downtown)",
      address: "149 Madison Ave",
      city: "Memphis, TN 38103",
      phone: "(901) 628-0086",
    },
    {
      id: 73,
      title: "小富贵 Little Petal Chinese 2(East Memphis)",
      address: "5167 Poplar Ave",
      city: "Memphis, TN 38117",
      phone: "(901) 668-9388",
      isNew: true, // NEW location flag
    },
    {
      id: null,
      title: "Little Petals 3",
      address: "890 W Poplar Ave",
      city: "Memphis, TN 38117",
      phone: null,
      comingSoon: true,
      comingSoonText: "Coming in 1 month",
    },
    {
      id: null,
      title: "Little Petals 4",
      address: "551 S Highland St",
      city: "Memphis, TN 38111",
      phone: null,
      comingSoon: true,
      comingSoonText: "Coming in 2 months",
    },
  ];

  return (
    <div className="bg-white text-dark py-5">
      <div className="container">
        <h2
          className="text-center fw-bold mb-5"
          style={{ color: "#9d2a00" }}
        >
          Our Locations
        </h2>

        <div className="row justify-content-center gy-4">
          {locations.map((loc, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-6">
              <div
                className="position-relative border rounded-4 shadow-sm h-100 p-4 text-center"
                style={{
                  borderColor: "rgba(157,42,0,0.15)",
                  background: "#fff",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 3px 8px rgba(157,42,0,0.2)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.boxShadow =
                    "0 2px 6px rgba(0,0,0,0.05)")
                }
              >
                {/* NEW Tag */}
                {loc.isNew && (
                  <span
                    className="position-absolute top-0 start-50 translate-middle badge rounded-pill fw-semibold"
                    style={{
                      backgroundColor: "#9d2a00",
                      color: "#fff",
                      fontSize: "0.75rem",
                      transform: "translate(-50%, -50%)",
                      padding: "6px 12px",
                      letterSpacing: "0.3px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  >
                    NEW
                  </span>
                )}

                <h5 className="fw-bold mb-3 text-dark">{loc.title}</h5>
                <p className="mb-1 fw-medium text-dark">{loc.address}</p>
                {loc.city && <p className="mb-1 text-muted">{loc.city}</p>}
                {loc.phone && (
                  <a
                    href={`tel:${loc.phone.replace(/[^0-9]/g, "")}`}
                    className="fw-semibold text-decoration-none d-block mb-3"
                    style={{ color: "#9d2a00" }}
                  >
                    {loc.phone}
                  </a>
                )}
                {loc.comingSoon ? (
                  <div
                    className="btn w-100 fw-semibold disabled"
                    style={{
                      backgroundColor: "#ccc",
                      color: "#666",
                      borderRadius: 12,
                      cursor: "default",
                      padding: "0.5rem 1rem",
                    }}
                  >
                    {loc.comingSoonText}
                  </div>
                ) : (
                  <button
                    onClick={() => handleToOrder(loc.id)}
                    className="btn w-100 fw-semibold"
                    style={{
                      backgroundColor: "#9d2a00",
                      color: "#fff",
                      borderRadius: 12,
                      transition: "background-color 0.2s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.target.style.backgroundColor = "#b83500")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.backgroundColor = "#9d2a00")
                    }
                  >
                    Order Here
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OrderStore;
